(function () {
  angular
    .module('kareo.ui.shared.directives.provider.k-npi-lookup', [
      'kareo.ui.shared.directives.validation.input-group',
      'kareo.ui.shared.directives.validation.prevent-form-submit',
      'kareo.ui.shared.directives.k-spinner',
      'kareo.ui.shared.directives.validation.k-valid-npi',
      'kareo.ui.shared.modules.api.k-npi-service'
    ])
    .component('kNpiLookup', {
      bindings: {
        loadingMessage: '@?', // default "Looking up NPI..."
        onLookup: '&', // param: npiInfo
        npi: '=?' // input npi, two-way bound
      },
      controller,
      controllerAs: 'vm',
      template: require('./k-npi-lookup.pug')()
    });

  controller.$inject = ['$q', 'kNpiService'];
  function controller($q, kNpiService) {
    const vm = this;

    vm.isLoading = false;
    vm.wasNotFound = false;

    vm.lookupAndNotify = lookupAndNotify;

    vm.$onInit = init;

    // -----------------------------------------------------------------------

    function init() {
      vm.npi = vm.npi || '';

      if (vm.loadingMessage === undefined) {
        vm.loadingMessage = 'Looking up NPI...';
      }
    }

    function lookupAndNotify() {
      vm.isLoading = true;
      kNpiService
        .lookupNPI(vm.npi)
        .then((npiInfo) => {
          if (!npiInfo) {
            return $q.reject();
          }
          vm.isLoading = false;
          vm.onLookup({ npiInfo });
        }).catch(() => {
          vm.isLoading = false;
          vm.wasNotFound = true;
        });
    }
  }
})();
